export default __webpack_public_path__ + "static/media/486.09fd736e.png";